// Shared email helpers — used by both the sandbox "Email me this report" CTA
// (in main.js) and the email gate inside the custom-process modal (in claude.js).
// Captured emails persist in localStorage under one key so the two flows
// agree on whether the user has already given us their address.

export const EMAIL_KEY = "mp-email";

export function isValidEmail(s: unknown): boolean {
  return typeof s === "string" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s.trim());
}

export function getCapturedEmail(): string {
  return localStorage.getItem(EMAIL_KEY) || "";
}

export function setCapturedEmail(s: string | null | undefined): void {
  if (s) localStorage.setItem(EMAIL_KEY, s);
}
